import { createSelector } from '@ngrx/store';
import { getMemberInterface } from '../getMemberInterface/get-member-interface.selector';

export const getMemberInterfaceValidation = createSelector(getMemberInterface, (memberInterface) => memberInterface.validation);
